require('../fonts/ionicons/css/ionicons.min.css');
require('../fonts/font-awesome/css/font-awesome.min.css');

require('./main.min.css');
require('./angular-material.min.css');
require('./angular-block-ui.css');
require('./ng-sortable.min.css');

require('./bootstrap-big-grid.min.css');
require('./dropzone.css');
require('./animate.css');
require('./angular-aside.min.css');

require('./pages/templates.css');
require('./pages/home-styles.css');
require('./pages/libraries.css');
require('./general.css');
require('./header.css');
require('./sidebar.css');
require('./typableDropdown.css');
require('./product-viewer.css');
require('./bootstrap.min.css');
require('./fabric.css');
require('./auth.css');
require('./mapModal.css');

require('../libs/color-picker/jqColor.css');
require('../../assets/styles/theme.scss');
require('../../assets/styles/common.scss');
